<template>
  <div id="content-page" class="content-page">
    <div class="iq-top-navbar">
      <div class="iq-navbar-custom">
        <nav>
          <b-row style="height: 90px">
            <b-col cols="4">
              <div style="float: left">
                <a class="cursor-point" @click="reload">
                  <img v-if="defaultAvatarLogo" :src="fileLogo" class="top-logo" />
                  <img v-else class="top-logo" v-bind:src="'data:image/jpeg;base64,' + fileLogo" />
                </a>
              </div>
            </b-col>
            <b-col cols="4" style="margin-top: 16px">
              <div class="iq-search-bar">
                <form action="#" class="searchbox">
                  <input class="text search-input" type="text" v-bind:placeholder="
                    $t('public.views.Pages.Ipros.placeHolder.searchDoctor')
                  " /><a class="search-link" href="#"><i class="ri-search-line"></i></a>
                </form>
              </div>
            </b-col>
            <b-col cols="4">
              <div style="float: right">
                <ul class="navbar-list">
                  <li>
                    <a class="
                                        search-toggle
                                        iq-waves-effect
                                        d-flex
                                        align-items-center
                                      " href="#">
                      <b-avatar class="mr-3" size="2.5em" v-bind:src="
                        user.avatarUrl
                          ? user.avatarUrl +
                          '/' +
                          getAuthentication()
                          : ''
                      "></b-avatar>
                      <div class="caption">
                        <h6 v-if="user && user.name" class="mb-0 line-height">
                          {{ user.name }}
                        </h6>
                        <h6 v-else class="mb-0 line-height">
                          {{ $t("public.views.Pages.Ipros.loggin") }}
                        </h6>
                        <span v-if="
                          user.role === 'PATIENT' &&
                          wallet.total !== undefined
                        " class="font-size-16">
                          {{ $t("public.views.Pages.Ipros.balance") }}:
                          {{ wallet.total.toFixed(2) }} €
                        </span>
                        <span v-else class="font-size-16">
                          <i class="fas fa-chevron-down"></i>
                        </span>
                      </div>
                    </a>
                    <div v-if="!user || !user.id" class="iq-sub-dropdown iq-dropdown">
                      <div class="iq-card shadow-none m-0">
                        <div class="iq-card-body p-0">
                          <div class="bg-primary p-3">
                            <h5 class="mb-0 text-white line-height">
                              {{
                                $t("public.views.Pages.Ipros.offLineSession")
                              }}
                            </h5>
                          </div>
                          <div class="d-inline-block w-100 text-center p-3">
                            <b-button variant="success" @click="login">
                              {{ $t("public.views.Pages.Ipros.loggin") }}
                              <i class="ri-login-box-line ml-2"></i>
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="iq-sub-dropdown iq-dropdown">
                      <div class="iq-card shadow-none m-0">
                        <div class="iq-card-body p-0">
                          <div class="bg-primary p-3">
                            <h5 class="mb-0 text-white line-height">
                              {{ $t("public.views.Pages.Ipros.hi") }}
                              {{ user.name }}
                            </h5>
                            <a v-if="
                              user.role === 'PATIENT' &&
                              wallet.total !== undefined
                            " class="text-white font-size-16" href="javascript:void(0)">
                              {{ $t("public.views.Pages.Ipros.balance") }}:
                              {{ wallet.total.toFixed(2) }} €
                            </a>
                            <span class="font-size-16 mr-2">
                              <b-badge v-if="user.role === 'ADMIN'" variant="danger">{{
                                $t("public.views.Pages.Ipros.admin")
                              }}</b-badge>
                            </span>
                            <span v-if="
                              user.organizationRoles &&
                              user.organizationRoles.length != 0
                            " class="font-size-16">
                              <b-badge v-for="(item, index) in user.organizationRoles" :key="index" variant="success">{{
                                item
                              }}</b-badge>
                            </span>
                          </div>
                          <div class="iq-sub-card iq-bg-primary-hover cursor-point" @click="goToHomePage">
                            <div class="media align-items-center">
                              <div class="
                                                  rounded
                                                  iq-card-icon
                                                  background-typography
                                                  text-white
                                                ">
                                <i class="fas fa-home"></i>
                              </div>
                              <div class="media-body ml-3">
                                <h6 class="mb-0">
                                  {{ $t("public.views.Pages.Ipros.homePage") }}
                                </h6>
                                <p class="mb-0 font-size-16">
                                  {{ $t("public.views.Pages.Ipros.private") }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="d-inline-block w-100 text-center p-3">
                            <a class="iq-bg-danger iq-sign-btn" href="javascript:void(0)" role="button" @click="logout">
                              {{ $t("public.views.Pages.Ipros.exit") }}
                              <i class="ri-login-box-line ml-2"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </b-col>
          </b-row>
        </nav>
      </div>
    </div>
    <b-container fluid>
      <b-row>
        <b-col lg="5">
          <iq-card class-name="iq-user-profile-block1">
            <template v-slot:body>
              <div class="user-details-block">
                <div v-if="ipros.professional" class="user-profile text-center">
                  <b-avatar size="150px" v-bind:src="ipros.professional.avatar"></b-avatar>
                </div>
                <div class="text-center mt-3">
                  <b-form-rating id="rating-inline" :disabled="true" inline value="4" variant="warning"></b-form-rating>
                </div>

                <div v-if="ipros && ipros.professional" class="text-center mt-3">
                  <h4>
                    <b>{{ ipros.professional.name }}
                      {{ ipros.professional.lastname }}</b>
                  </h4>

                  <p>{{ ipros.professional.city }}</p>
                </div>
                <div v-if="ipros && ipros.professional && ipros.professional.email" class="text-center">
                  <a :href="'mailto:' + ipros.professional.email" role="button">
                    <b-button variant="primary">
                      {{ $t("public.views.Pages.Ipros.contact") }}
                    </b-button>
                  </a>
                </div>
                <hr />
                <ul class="
                                    doctoe-sedual
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    p-0
                                  ">
                  <li class="text-center">
                    <h3 class="counter">
                      <lang-flag v-for="lang in ipros.professionalLanguage" :key="lang" :iso="lang" class="mr-2" />
                    </h3>
                  </li>
                  <li v-if="ipros.professional && ipros.professional.sector" class="text-center">
                    <h3 class="counter">{{ ipros.professional.sector }}</h3>
                  </li>
                </ul>
              </div>
            </template>
          </iq-card>
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-user-shield"></i>
                {{ $t("public.views.Pages.Ipros.public.my") }}
              </h4>
            </template>
            <template v-slot:body>
              <div v-html="ipros.my"></div>
            </template>
          </iq-card>
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-filter"></i>
                {{ $t("public.views.Pages.Ipros.public.speciality") }}
              </h4>
            </template>
            <template v-slot:body>
              <div v-html="ipros.speciality"></div>
            </template>
          </iq-card>
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-file-video"></i>
                {{ $t("public.views.Pages.Ipros.public.videos") }}
              </h4>
            </template>
            <template v-slot:body>
              <div v-html="ipros.videos"></div>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="7">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-calendar-alt"></i>
                {{ $t("public.views.Pages.Ipros.schedule") }}
              </h4>
            </template>
            <template v-slot:body>
              <form-wizard color="#0cb0c2" shape="square" v-bind:subtitle="
                $t('public.views.Pages.Ipros.formWizard.subtitle')
              " v-bind:title="$t('public.views.Pages.Ipros.formWizard.title')">
                <tab-content icon="far fa-comment-alt" v-bind:title="
                  $t('public.views.Pages.Ipros.formWizard.tabContent')
                ">
                  <b-form-group label-for="visitType">
                    <template slot="label">
                      {{ $t("public.views.Pages.Ipros.visitType") }}: *
                    </template>

                    <multiselect v-model="visitType" :multiple="false" :options="visitTypeSelect" label="name"
                      track-by="id" v-bind:class="{
                        'text-danger': isFormVisitTypeErrors,
                        'is-invalid': isFormVisitTypeErrors,
                      }" v-bind:deselectGroupLabel="
  $t(
    'public.views.Pages.Ipros.multiselect.deselectGroupLabel'
  )
" v-bind:deselectLabel="
  $t('public.views.Pages.Ipros.multiselect.deselectLabel')
" v-bind:placeholder="
  $t('public.views.Pages.Ipros.multiselect.placeholder')
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Ipros.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t('public.views.Pages.Ipros.multiselect.selectLabel')
" v-bind:selectedLabel="
  $t('public.views.Pages.Ipros.multiselect.selectedLabel')
" @blur="checkVisitType(visitTypes)">
                      <template slot="option" slot-scope="props">
                        <b-list-group-item class="d-flex align-items-center">
                          <i :style="'color: ' + props.option.colour" class="fas fa-circle mr-2"></i><span
                            class="mr-auto title-typography-color">{{
                              props.option.name
                            }}</span>
                        </b-list-group-item>
                      </template>
                      <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                          class="multiselect__single">{{ values.length }}
                          {{
                            $t("public.views.Pages.Ipros.selectedVisitType")
                          }}</span></template>
                    </multiselect>
                    <ul v-if="isFormVisitTypeErrors">
                      <li v-for="(error, index) in validatorStep1.getErrors(
                        'visitType'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>
                </tab-content>
                <tab-content icon="fas fa-map-marker-alt" v-bind:title="
                  $t('public.views.Pages.Ipros.formWizard.tabContent2')
                ">
                  <div v-if="visitType">
                    <b-form-group label-for="online">
                      <template slot="label">
                        {{ $t("public.views.Pages.Ipros.visitPlace") }}: *
                      </template>
                      <b-form-radio v-if="visitType.priceOnlineActive" v-model="online" name="online" value="true">{{
                        $t("public.views.Pages.Ipros.online")
                      }}
                      </b-form-radio>
                      <b-form-radio v-if="visitType.priceOfflineActive" v-model="online" name="online" value="false">{{
                        $t("public.views.Pages.Ipros.offline")
                      }}
                      </b-form-radio>
                    </b-form-group>
                  </div>
                </tab-content>
                <tab-content icon="fas fa-calendar-alt" v-bind:title="
                  $t('public.views.Pages.Ipros.formWizard.tabContent1')
                ">
                  <b-form-group label-for="price">
                    <template slot="label">{{ $t("public.views.Pages.Ipros.price") }}:
                    </template>
                    <b-badge variant="success">{{ getPriceEvent() }} €
                    </b-badge>
                  </b-form-group>
                  <b-form-group label-for="dateAfter">
                    <template slot="label">{{ $t("public.views.Pages.Ipros.visitDate") }}: *
                    </template>
                    <date-picker v-model="dateEvent" :format="myFormat" :formatter="momentFormat" class="w-100"
                      type="date" v-bind:class="{
                        'text-danger': isFormDateEventErrors,
                        'is-invalid': isFormDateEventErrors,
                      }" @change="changeDayHeadersHoursTable()"></date-picker>
                    <ul v-if="isFormDateEventErrors">
                      <li v-for="(error, index) in validatorStep2.getErrors(
                        'dateEvent'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>
                  <b-form-group label-for="dateAfter">
                    <template slot="label">{{ $t("public.views.Pages.Ipros.avaliableHours") }}: *
                    </template>
                    <b-table v-if="dateEvent" :fields="fields" :items="scheduleWorkschedule" hover striped>
                      <template #head(monday)="data">
                        <div class="text-center">
                          <span>{{ data.label.toUpperCase() }}</span>
                          <h6>{{ data.field.date }}</h6>
                        </div>
                      </template>
                      <template #head(tuesday)="data">
                        <div class="text-center">
                          <span>{{ data.label.toUpperCase() }}</span>
                          <h6>{{ data.field.date }}</h6>
                        </div>
                      </template>
                      <template #head(wednesday)="data">
                        <div class="text-center">
                          <span>{{ data.label.toUpperCase() }}</span>
                          <h6>{{ data.field.date }}</h6>
                        </div>
                      </template>
                      <template #head(thursday)="data">
                        <div class="text-center">
                          <span>{{ data.label.toUpperCase() }}</span>
                          <h6>{{ data.field.date }}</h6>
                        </div>
                      </template>
                      <template #head(friday)="data">
                        <div class="text-center">
                          <span>{{ data.label.toUpperCase() }}</span>
                          <h6>{{ data.field.date }}</h6>
                        </div>
                      </template>
                      <template #head(saturday)="data">
                        <div class="text-center">
                          <span>{{ data.label.toUpperCase() }}</span>
                          <h6>{{ data.field.date }}</h6>
                        </div>
                      </template>
                      <template #head(sunday)="data">
                        <div class="text-center">
                          <span>{{ data.label.toUpperCase() }}</span>
                          <h6>{{ data.field.date }}</h6>
                        </div>
                      </template>
                      <!-- A custom formatted column -->
                      <template #cell(monday)="data">
                        <div v-if="data.value.timeStart && data.value.timeEnd">
                          <b-badge :variant="
                            data.value.status === 'FREE'
                              ? 'success'
                              : 'danger'
                          " class="cursor-point" @click="
  openModalInfoPay(
    data.value.timeStart,
    data.value.timeEnd,
    1,
    data.field.date,
    data.value.status
  )
">{{ data.value.timeStart }} -
                            {{ data.value.timeEnd }}
                          </b-badge>
                        </div>
                      </template>
                      <template #cell(tuesday)="data">
                        <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            2,
                            data.field.date,
                            data.value.status
                          )
                        ">
                          <b-badge :variant="
                            data.value.status === 'FREE'
                              ? 'success'
                              : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                            {{ data.value.timeEnd }}
                          </b-badge>
                        </div>
                      </template>
                      <template #cell(wednesday)="data">
                        <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            3,
                            data.field.date,
                            data.value.status
                          )
                        ">
                          <b-badge :variant="
                            data.value.status === 'FREE'
                              ? 'success'
                              : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                            {{ data.value.timeEnd }}
                          </b-badge>
                        </div>
                      </template>
                      <template #cell(thursday)="data">
                        <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            4,
                            data.field.date,
                            data.value.status
                          )
                        ">
                          <b-badge :variant="
                            data.value.status === 'FREE'
                              ? 'success'
                              : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                            {{ data.value.timeEnd }}
                          </b-badge>
                        </div>
                      </template>
                      <template #cell(friday)="data">
                        <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            5,
                            data.field.date,
                            data.value.status
                          )
                        ">
                          <b-badge :variant="
                            data.value.status === 'FREE'
                              ? 'success'
                              : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                            {{ data.value.timeEnd }}
                          </b-badge>
                        </div>
                      </template>
                      <template #cell(saturday)="data">
                        <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            6,
                            data.field.date,
                            data.value.status
                          )
                        ">
                          <b-badge :variant="
                            data.value.status === 'FREE'
                              ? 'success'
                              : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                            {{ data.value.timeEnd }}
                          </b-badge>
                        </div>
                      </template>
                      <template #cell(sunday)="data">
                        <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            0,
                            data.field.date,
                            data.value.status
                          )
                        ">
                          <b-badge :variant="
                            data.value.status === 'FREE'
                              ? 'success'
                              : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                            {{ data.value.timeEnd }}
                          </b-badge>
                        </div>
                      </template>
                    </b-table>
                    <b-alert v-else show variant="success">{{
                      $t("public.views.Pages.Ipros.selectDateSchedule")
                    }}
                    </b-alert>
                  </b-form-group>
                </tab-content>
                <template slot="footer" slot-scope="props">
                  <div class="wizard-footer-left">
                    <wizard-button v-if="props.activeTabIndex > 0" :style="props.fillButtonStyle"
                      @click.native="clickStep1(props)">{{
                        $t("public.views.Pages.Ipros.previous")
                      }}
                    </wizard-button>
                  </div>
                  <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" :style="props.fillButtonStyle" class="wizard-footer-right"
                      @click.native="clickStep2(props)">{{ $t("public.views.Pages.Ipros.next") }}
                    </wizard-button>
                  </div>
                </template>
              </form-wizard>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-modal id="modal-pay" centered hide-footer size="sm">
        <template #modal-title>{{
          $t("public.views.Pages.Ipros.pay")
        }}
        </template>
        <template #modal-cancel>{{
          $t("public.views.Pages.Ipros.cancel")
        }}
        </template>
        <div class="payment-btn-center">
          <i v-if="
            user &&
            user.userOrganizations &&
            user.userOrganizations[0] &&
            user.userOrganizations[0].paymentModePasarelaPaypal
          " id="btnPaypal" class="fab fa-paypal fa-4x fa-fw cursor-point" @click="showPaypalPayment"></i>
          <b-popover v-if="
            user &&
            user.userOrganizations &&
            user.userOrganizations[0] &&
            user.userOrganizations[0].paymentModePasarelaPaypal
          " :target="'btnPaypal'" placement="botton" triggers="hover focus">
            <template #title>{{
              $t("public.views.Pages.Ipros.btnPaypal")
            }}
            </template>
          </b-popover>
          <i v-if="
            user &&
            user.userOrganizations &&
            user.userOrganizations[0] &&
            user.userOrganizations[0].paymentModePasarelaStripe
          " id="btnStripe" class="fab fa-stripe fa-4x fa-fw cursor-point" @click="showStripePayment"></i>
          <b-popover v-if="
            user &&
            user.userOrganizations &&
            user.userOrganizations[0] &&
            user.userOrganizations[0].paymentModePasarelaStripe
          " :target="'btnStripe'" placement="botton" triggers="hover focus">
            <template #title>{{
              $t("public.views.Pages.Ipros.btnStripe")
            }}
            </template>
          </b-popover>
          <i v-if="
            user &&
            user.userOrganizations &&
            user.userOrganizations[0] &&
            user.userOrganizations[0].paymentModePasarelaWallet
          " id="btnWallet" class="fas fa-wallet fa-4x fa-fw cursor-point" @click="showCashPayment"></i>
          <b-popover v-if="
            user &&
            user.userOrganizations &&
            user.userOrganizations[0] &&
            user.userOrganizations[0].paymentModePasarelaWallet
          " :target="'btnWallet'" placement="botton" triggers="hover focus">
            <template #title>{{
              $t("public.views.Pages.Ipros.btnWallet")
            }}
            </template>
          </b-popover>
        </div>
      </b-modal>
      <b-modal id="modal-info-pay" centered size="lg" @ok="saveFormStep1">
        <template #modal-title>{{ $t("public.views.Pages.Ipros.appoimentSchedule") }}
        </template>
        <template #modal-ok>
          {{ $t("public.views.Pages.Ipros.schedule") }}
        </template>
        <template #modal-cancel>{{
          $t("public.views.Pages.Ipros.cancel")
        }}
        </template>

        <b-row>
          <b-col cols="6">
            <b-form-group v-if="dayInfo" label-for="dayInfo">
              <template slot="label">{{ $t("public.views.Pages.Ipros.day") }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ dayInfo }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group v-if="dayInfo" label-for="dayInfo">
              <template slot="label">{{ $t("public.views.Pages.Ipros.date") }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ dateInfo }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group v-if="hourStartInfo" label-for="hourStartInfo">
              <template slot="label">{{ $t("public.views.Pages.Ipros.startHour") }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ hourStartInfo }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group v-if="hourEndInfo" label-for="hourEndInfo">
              <template slot="label">{{ $t("public.views.Pages.Ipros.endHour") }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ hourEndInfo }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group v-if="visitType" label-for="visitType">
              <template slot="label">{{ $t("public.views.Pages.Ipros.visitType") }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <i :style="'color: ' + visitType.colour" class="fas fa-circle mr-2"></i>
                  {{ visitType.name }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="price">
              <template slot="label">{{ $t("public.views.Pages.Ipros.price") }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <b-badge variant="success">{{ getPriceEvent() }} €</b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
      <LoginModal ref="loginModal" :professionalId="professionalId"></LoginModal>

      <notifications group="notificacions" />
    </b-container>
  </div>
</template>
<script>
import routes from "../../router/index";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";

import { mapActions, mapGetters } from "vuex";

import userService from "../../services/user";
import walletService from "../../services/wallet";
import organizationService from "../../services/organization";
import iprosService from "../../services/ipros";
import utilsService from "../../services/utils";

import LoginModal from "../../components/account/LoginModal";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import validator from "vue-m-validator";

import LangFlag from "vue-lang-code-flags";

export default {
  name: "IprosPublic",
  components: {
    LangFlag: LangFlag,
    FormWizard,
    TabContent,
    WizardButton,
    Multiselect,
    DatePicker,
    LoginModal,
  },
  mounted() {
    this.$root.$on("reload-user", (obj) => {
      if (
        localStorage.getItem("authorization") &&
        localStorage.getItem("userId")
      ) {
        this.getUser();
      }
    });
    if (
      localStorage.getItem("authorization") &&
      localStorage.getItem("userId")
    ) {
      //Verificacion pay
      this.verifyPay();
      this.getUser();
    }
    this.get();
  },
  data() {
    return {
      professionalId: this.$route.query.professionalId,
      //If login
      user: {},
      wallet: {},
      //---
      online: false,
      validatorStep2: validator,
      validatorStep1: validator,
      visitTypeSelect: [],
      visitType: null,
      dateEvent: "",
      dateInfo: "",
      hourEndInfo: "",
      hourStartInfo: "",
      dayInfo: "",
      scheduleWorkschedule: [],
      search: "",

      fields: [
        { key: "monday", label: "Lunes", date: "" },
        { key: "tuesday", label: "Martes", date: "" },
        { key: "wednesday", label: "Miércoles", date: "" },
        { key: "thursday", label: "Jueves", date: "" },
        { key: "friday", label: "Viernes", date: "" },
        { key: "saturday", label: "Sábado", date: "" },
        { key: "sunday", label: "Domingo", date: "" },
      ],
      //Calendar:
      value: "",
      focus: "",
      typeToLabel: {
        month: this.$i18n.t("public.views.Pages.Ipros.month"),
        week: this.$i18n.t("public.views.Pages.Ipros.week"),
        day: this.$i18n.t("public.views.Pages.Ipros.day"),
        "4day": this.$i18n.t("public.views.Pages.Ipros.4day"),
      },
      weekView: [1, 2, 3, 4, 5, 6, 0],
      //--
      homeURL: {
        type: Object,
        default: () => ({ name: "public.singin" }),
      },
      defaultLoginLogo: true,
      defaultAvatarLogo: true,
      defaultAvatarProfessionalLogo: true,
      fileLoginLogo: require("../../assets/images/user/woman_profile.jpg"),
      fileLogo: "",
      fileProfessionalLogo: "",
      start: this.getActualDateToVcalendar(),
      ipros: {},
      events: [],
      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
    };
  },
  computed: {
    isFormDateEventErrors() {
      let errors = this.validatorStep2.getErrors("dateEvent");
      return errors && errors.length > 0;
    },
    isFormVisitTypeErrors() {
      let errors = this.validatorStep1.getErrors("visitType");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    getPriceEvent() {
      if (this.visitType) {
        if (this.online) {
          return this.visitType.priceOnline;
        } else {
          return this.visitType.priceOffline;
        }
      }
      return "reload page";
    },
    changeDayHeadersHoursTable() {
      this.getWorkscheduleByVisitType(
        this.visitType,
        moment(utilsService.adjustDateTime(moment(this.dateEvent).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")))
      );
      var dayNow = moment(new Date(this.dateEvent)).isoWeekday();

      var fildsResult = [];

      let dataMonday;

      if (dayNow !== 1) {
        dataMonday = moment(new Date(this.dateEvent));

        dataMonday = dataMonday.subtract(dayNow - 1, "days");
      } else {
        dataMonday = moment(new Date(this.dateEvent));
      }

      var j = 1;
      for (var i = 0; i <= 6; i++) {
        let dateNowTmp = moment(dataMonday);

        if (j !== 0) {
          var dateNowItem = dateNowTmp.add(j - 1, "days");
        } else {
          var dateNowItem = dateNowTmp.add(j + 6, "days");
        }
        let field = {
          key: this.getDayEnglishByInt(j),
          label: this.myDayFormatInfo(j),
          date: dateNowItem.format("DD/MM/yyyy"),
        };
        fildsResult.push(field);

        if (j === 6) {
          j = 0;
        } else {
          j++;
        }
      }

      //regenerate previous

      this.fields = fildsResult;
    },
    reload() {
      location.reload();
    },
    //Pay
    async verifyPay() {
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined &&
        this.$route.query.paymentId !== undefined &&
        this.$route.query.iprosEventId !== undefined &&
        this.$route.query.PayerID !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.paySuccess(
            this.$route.query.iprosEventId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      } else {
        if (
          this.$route.query.action !== undefined &&
          this.$route.query.mode !== undefined &&
          this.$route.query.tokenback !== undefined &&
          this.$route.query.token !== undefined &&
          this.$route.query.iprosEventId !== undefined
        ) {
          if (this.$route.query.action === "cancel") {
            let data = {
              tokenPaypal: this.$route.query.token,
              paymentIdPaypal: this.$route.query.paymentId,
              payerIDPaypal: this.$route.query.PayerID,
            };

            this.payCancel(
              this.$route.query.iprosEventId,
              this.$route.query.mode,
              this.$route.query.tokenback,
              data
            );
          }
        } else {
          if (
            this.$route.query.action !== undefined &&
            this.$route.query.mode !== undefined &&
            this.$route.query.tokenback !== undefined &&
            this.$route.query.iprosEventId !== undefined
          ) {
            if (this.$route.query.action === "success") {
              let data = {
                tokenPaypal: "",
                paymentIdPaypal: "",
                payerIDPaypal: "",
              };

              this.paySuccess(
                this.$route.query.iprosEventId,
                this.$route.query.mode,
                this.$route.query.tokenback,
                data
              );
            }
            if (this.$route.query.action === "cancel") {
              let data = {
                tokenPaypal: "",
                paymentIdPaypal: "",
                payerIDPaypal: "",
              };

              this.payCancel(
                this.$route.query.iprosEventId,
                this.$route.query.mode,
                this.$route.query.tokenback,
                data
              );
            }
          }
        }
      }
    },
    paySuccess(iprosEventId, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        iprosService.paySuccess(
          this.$route.query.professionalId,
          iprosEventId,
          mode,
          token,
          data
        ),
        (response) => {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Ipros.notification.title"),
            text: this.$i18n.t("public.views.Pages.Ipros.notification.descPay"),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.paySuccess",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.$route.query.professionalId,
              iprosEventId: iprosEventId,
              mode: mode,
              token: token,
              data: data
            })
          });
        },
        " "
      );
    },
    payCancel(iprosEventId, mode, token, data) {
      let self = this;
      this.$awn.asyncBlock(
        iprosService.payCancel(
          this.$route.query.professionalId,
          iprosEventId,
          mode,
          token,
          data
        ),
        (response) => {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Ipros.notification.error"),
            text: this.$i18n.t(
              "public.views.Pages.Ipros.notification.descErrorPay"
            ),
            type: "error",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.payCancel",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.$route.query.professionalId,
              iprosEventId: iprosEventId,
              mode: mode,
              token: token,
              data: data
            })
          });
        },
        " "
      );
    },
    getWallet() {
      let self = this;

      walletService
        .get(this.user.walletId)
        .then((response) => {
          if (response) {
            self.wallet = response.data;
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    showStripePayment() {
      let self = this;

      let data = {
        visitTypeId: this.visitType.id,
        startTime: this.hourStartInfo,
        endTime: this.hourEndInfo,
        date: moment("DD/MM/YYYY"),
        online: this.online,
      };

      this.$awn.asyncBlock(
        iprosService.payStripe(this.$route.query.professionalId, data),
        (response) => {
          if (response) {
            self.stripe = response.data;

            let stripeInit = loadStripe(self.stripe.publicKey);
            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.payStripe",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.$route.query.professionalId, data: data
            })
          });
        },
        " "
      );
    },
    showCashPayment() {
      let self = this;

      let data = {
        visitTypeId: this.visitType.id,
        startTime: this.hourStartInfo,
        endTime: this.hourEndInfo,
        date: moment(this.dateInfo, "DD/MM/YYYY").format(
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
        ),
        online: this.online,
      };

      this.$awn.asyncBlock(
        iprosService.payCash(this.$route.query.professionalId, data),
        (response) => {
          if (response) {
            self.$bvModal.hide("modal-pay");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Ipros.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Ipros.notification.descPay"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          self.$swal(
            this.$i18n.t("public.views.Pages.Ipros.errorSwal.text"),
            this.$i18n.t("public.views.Pages.Ipros.errorSwal.text1"),
            this.$i18n.t("public.views.Pages.Ipros.errorSwal.text2")
          );
        },
        " "
      );
    },
    showPaypalPayment() {
      let self = this;

      let data = {
        visitTypeId: this.visitType.id,
        startTime: this.hourStartInfo,
        endTime: this.hourEndInfo,
        date: moment(this.dateInfo, "DD/MM/YYYY").format(
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
        ),
        online: this.online,
      };

      this.$awn.asyncBlock(
        iprosService.payPaypal(this.$route.query.professionalId, data),
        (response) => {
          if (response) {
            self.paypal = response.data;
            window.location.href = self.paypal.url;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.payPaypal",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.$route.query.professionalId, data: data
            })
          });
        },
        " "
      );
    },
    goToHomePage() {
      if (this.user && this.user.role) {
        if (this.user.role === "PATIENT") {
          this.$router.push({ name: "auth.patient.dashboard" });
        } else {
          this.$router.push({ name: "auth.professional.dashboard" });
        }
      }
    },
    saveFormStep1() {
      this.$bvModal.show("modal-pay");
    },
    logout() {
     // utilsService.auditActivity({ action: "CREATE", module: "AUTH_LOGOUT", info: "" });

      localStorage.removeItem("organizationRoles");
      localStorage.removeItem("authorization");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("type");
      localStorage.removeItem("userId");

      this.$router.push({ name: "public.signin" });

    },
    async getUser() {
      let self = this;

      this.$awn.asyncBlock(
        userService.get(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.user = response.data;

            if (self.user.role === "PATIENT") {
              self.getWallet();
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        },
        " "
      );
    },
    openModalInfoPay(start, end, day, date, status) {
      if (status === "FREE") {
        this.checkFormStep2();

        if (this.user.id && this.user.role === "PATIENT") {
          if (this.validatorStep2.errors.length === 0) {
            this.hourEndInfo = end;
            this.hourStartInfo = start;
            this.dayInfo = this.myDayFormatInfo(day);
            this.dateInfo = date;
            this.$bvModal.show("modal-info-pay");
          } else {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Ipros.notification.error"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Ipros.notification.descErrorStep1"
              ),
              type: "error",
            });
          }
        }
        if (
          this.user.id &&
          (this.user.role === "PROFESSIONAL" ||
            this.user.role === "ADMIN" ||
            this.user.role === "SUPERADMIN")
        ) {
          this.$swal(
            this.$i18n.t("public.views.Pages.Ipros.errorSwal.text3"),
            this.$i18n.t("public.views.Pages.Ipros.errorSwal.text4"),
            this.$i18n.t("public.views.Pages.Ipros.errorSwal.text5")
          );
        }
        if (!this.user.id) {
          this.$refs.loginModal.openModal();
        }
      }
    },
    checkFormStep2() {
      this.checkDateEvent(this.dateEvent);
    },
    checkFormStep1() {
      this.checkVisitType(this.visitType);
    },
    //Form 1
    clickStep2(props) {
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        props.nextTab();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.Pages.Ipros.notification.error"),
          text: this.$i18n.t(
            "public.views.Pages.Ipros.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    clickStep1(props) {
      props.prevTab();
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkDateEvent(_date) {
      const dateEvent = _date;

      const RULE_1 = {
        expression: !dateEvent || dateEvent === "",
        name: "dateEvent",
        msg: this.$i18n.t("public.views.Pages.Ipros.errors.erDate"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkVisitType(_visitTypes) {
      const visitTypes = _visitTypes;

      const RULE_1 = {
        expression: visitTypes === null || visitTypes.length === 0,
        name: "visitType",
        msg: this.$i18n.t("public.views.Pages.Ipros.errors.erVisitType"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    login() {
      //Open modal login or register
      this.$refs.loginModal.openModal();
    },
    getActualDateToVcalendar() {
      return (
        new Date().getFullYear() +
        "-" +
        ("0" + (new Date().getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date().getDate()).slice(-2)
      );
    },
    getDayEnglishByInt(day) {
      if (day === 1) {
        return "monday";
      }
      if (day === 2) {
        return "tuesday";
      }
      if (day === 3) {
        return "wednesday";
      }
      if (day === 4) {
        return "thursday";
      }
      if (day === 5) {
        return "friday";
      }
      if (day === 6) {
        return "saturday";
      }
      if (day === 0) {
        return "sunday";
      }
      return null;
    },
    myDayFormatInfo(day) {
      if (day === 1) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.monday");
      }
      if (day === 2) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.tuesday");
      }
      if (day === 3) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.wednesday");
      }
      if (day === 4) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.thursday");
      }
      if (day === 5) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.friday");
      }
      if (day === 6) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.saturday");
      }
      if (day === 0) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.sunday");
      }
      return "";
    },
    myDayFormat(day) {
      if (day.weekday === 1) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.monday");
      }

      if (day.weekday === 2) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.tuesday");
      }

      if (day.weekday === 3) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.wednesday");
      }

      if (day.weekday === 4) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.thursday");
      }

      if (day.weekday === 5) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.friday");
      }

      if (day.weekday === 6) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.saturday");
      }

      if (day.weekday === 0) {
        return this.$i18n.t("public.views.Pages.Ipros.weekday.sunday");
      }
    },
    filterByVisitType(hours) {
      let self = this;

      let ret = [];

      if (hours) {
        hours.forEach(function (item) {
          let insert = false;
          if (item.visitTypes) {
            item.visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!insert) {
                  ret.push(hours);
                  insert = true;
                }
              }
            });
          }
        });
      }

      return ret;
    },
    generateWorkscheduleIpros() {
      let self = this;

      this.scheduleWorkschedule = [];

      let data = {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      };

      this.workscheduleIpros.daySchedules.forEach(function (item) {
        if (item.day === "MONDAY") {
          let repit = new Set();

          item.hourSchedules.forEach(function (item) {
            if (!repit.has(item.timeStart)) {
              repit.add(item.timeStart);
              data.monday.push(item);
            }
          });
        }

        if (item.day === "TUESDAY") {
          let repit = new Set();

          item.hourSchedules.forEach(function (item) {
            if (!repit.has(item.timeStart)) {
              repit.add(item.timeStart);
              data.tuesday.push(item);
            }
          });
        }

        if (item.day === "WENDNESDAY") {
          let repit = new Set();

          item.hourSchedules.forEach(function (item) {
            if (!repit.has(item.timeStart)) {
              repit.add(item.timeStart);
              data.wednesday.push(item);
            }
          });
        }

        if (item.day === "THURSDAY") {
          let repit = new Set();

          item.hourSchedules.forEach(function (item) {
            if (!repit.has(item.timeStart)) {
              repit.add(item.timeStart);
              data.thursday.push(item);
            }
          });
        }

        if (item.day === "FRIDAY") {
          let repit = new Set();

          item.hourSchedules.forEach(function (item) {
            if (!repit.has(item.timeStart)) {
              repit.add(item.timeStart);
              data.friday.push(item);
            }
          });
        }

        if (item.day === "SATURDAY") {
          let repit = new Set();

          item.hourSchedules.forEach(function (item) {
            if (!repit.has(item.timeStart)) {
              repit.add(item.timeStart);
              data.saturday.push(item);
            }
          });
        }

        if (item.day === "SUNDAY") {
          let repit = new Set();

          item.hourSchedules.forEach(function (item) {
            if (!repit.has(item.timeStart)) {
              repit.add(item.timeStart);
              data.sunday.push(item);
            }
          });
        }
      });

      let calculeMax = this.calculeLengthMaxDays(data);

      for (var i = 0; i < calculeMax; i++) {
        let dataFinal = {
          monday: {},
          tuesday: {},
          wednesday: {},
          thursday: {},
          friday: {},
          saturday: {},
          sunday: {},
        };
        if (i < data.monday.length) {
          if (data.monday[i].visitTypes) {
            let store = false;

            data.monday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!store) {
                  dataFinal.monday = data.monday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.tuesday.length) {
          if (data.tuesday[i].visitTypes) {
            let store = false;

            data.tuesday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!store) {
                  dataFinal.tuesday = data.tuesday[i];
                }
              }
            });
          }
        }
        if (i < data.wednesday.length) {
          if (data.wednesday[i].visitTypes) {
            let store = false;

            data.wednesday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!store) {
                  dataFinal.wednesday = data.wednesday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.thursday.length) {
          if (data.thursday[i].visitTypes) {
            let store = false;

            data.thursday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!store) {
                  dataFinal.thursday = data.thursday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.friday.length) {
          if (data.friday[i].visitTypes) {
            let store = false;

            data.friday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!store) {
                  dataFinal.friday = data.friday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.saturday.length) {
          if (data.saturday[i].visitTypes) {
            let store = false;

            data.saturday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!store) {
                  dataFinal.saturday = data.saturday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.sunday.length) {
          if (data.sunday[i].visitTypes) {
            let store = false;

            data.sunday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.id) {
                if (!store) {
                  dataFinal.sunday = data.sunday[i];
                  store = true;
                }
              }
            });
          }
        }

        self.scheduleWorkschedule.push(dataFinal);
      }
    },
    calculeLengthMaxDays(data) {
      let max = 0;

      if (max < data.monday.length) {
        max = data.monday.length;
      }
      if (max < data.tuesday.length) {
        max = data.tuesday.length;
      }
      if (max < data.wednesday.length) {
        max = data.wednesday.length;
      }
      if (max < data.thursday.length) {
        max = data.thursday.length;
      }
      if (max < data.friday.length) {
        max = data.friday.length;
      }
      if (max < data.saturday.length) {
        max = data.saturday.length;
      }
      if (max < data.sunday.length) {
        max = data.sunday.length;
      }

      return max;
    },
    async getWorkscheduleByVisitType(visitType, startDate) {
      let self = this;

      let data = {
        visitType: visitType.id,
        startDate: startDate,
      };

      this.$awn.asyncBlock(
        iprosService.getPublicWorkscheduleIprosFree(
          this.$route.query.professionalId,
          data
        ),
        (response) => {
          self.workscheduleIpros = response.data;
          self.generateWorkscheduleIpros();
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.getPublicWorkscheduleIprosFree",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.$route.query.professionalId,
              data: data
            })
          });
        }
      );
    },
    async get() {
      let self = this;

      this.$awn.asyncBlock(
        iprosService.getPublic(this.$route.query.professionalId),
        (response) => {
          if (response) {
            self.ipros = response.data;

            if (
              self.ipros.professional &&
              self.ipros.professional.organizationId
            ) {
              self.getLogoOrganization(self.ipros.professional.organizationId);
            }
            if (
              self.ipros.professional &&
              self.ipros.professionalLanguage &&
              self.ipros.professionalLanguage.length !== 0
            ) {
              self.ipros.professionalLanguage.forEach(function (item) {
                if (item === "SP") {
                  self.flagSpActive = true;
                }
                if (item === "EN") {
                  self.flagEnActive = true;
                }
                if (item === "CAT") {
                  self.flagCatActive = true;
                }
              });
            }

            self.visitTypeSelect = response.data.visitTypes;
          }
        },
        (error) => {
          routes.push({ name: "public.signin" });
        }
      );
    },
    getLogoOrganization(organizationId) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findLogo(organizationId),
        (response) => {
          if (response) {
            self.getImageLogoOrganization(response.data);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findLogo",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: organizationId
            })
          });
        }
      );
    },
    getImageLogoOrganization(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatarLogo = false;
            self.fileLogo = response.data.data;
          } else {
            self.defaultAvatarLogo = true;
            self.fileLogo = require("../../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatarLogo = true;
          self.fileLogo = require("../../assets/images/logo.png");
        });
    },
    getLogoProfessional(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatarProfessionalLogo = false;
            self.fileProfessionalLogo = response.data.data;
          } else {
            self.defaultAvatarProfessionalLogo = true;
            self.fileProfessionalLogo = require("../../assets/images/user/woman_profile.jpg");
          }
        })
        .catch(function (error) {
          self.defaultAvatarProfessionalLogo = true;
          self.fileProfessionalLogo = require("../../assets/images/user/woman_profile.jpg");
        });
    },
  },
};
</script>
